import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';
import CTASection from '@/pages/home/components/CTASection';

const ServicesPage = () => {
  return (
    <main>
      <ServicesHero />
      <ServicesDetail />
      <CTASection />
    </main>
  );
};

export default ServicesPage;
